import React from "react";

const Linkedin = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="22"
      height="22"
      viewBox="0 0 22 22"
      {...props}
    >
      <g fill="none" fillRule="evenodd">
        <g fill="currentColor">
          <path
            d="M16.667 15.757h-2.5V11.11c0-2.793-3.334-2.582-3.334 0v4.647h-2.5V6.635h2.5v1.463c1.164-2.144 5.834-2.303 5.834 2.054v5.605zM5.417 5.583c-.805 0-1.459-.655-1.459-1.463s.654-1.463 1.459-1.463 1.458.655 1.458 1.463-.653 1.463-1.458 1.463zm-1.25 10.174h2.5V6.635h-2.5v9.122zM15.833 0H4.167C1.866 0 0 1.857 0 4.147v11.61c0 2.29 1.866 4.147 4.167 4.147h11.666c2.302 0 4.167-1.857 4.167-4.147V4.147C20 1.857 18.135 0 15.833 0z"
            transform="translate(1 1)"
          />
        </g>
      </g>
    </svg>
  );
};

export default Linkedin;
